// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};
// config
var APP = {
	bp: {
		mobile: 850
	}
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class ContactAddAcceptLink {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const dateWrap = "." + this.el;
    $(dateWrap).each(function(){
      let acceptText = $(this).find('.mwform-checkbox-field-text').html();
      let toPP = $(this).data('accept');
      let replaceText = '個人情報の取り扱い';
      let completeText = acceptText.replace(replaceText,'<a href="'+toPP+'" target="_blank">個人情報の取り扱い</a>');
      $(this).find('.mwform-checkbox-field-text').html(completeText);
    })
  }
}

class ContactCheckBox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).find('input[type=checkbox],input[type=radio]').each(function(){
      if($(this).prop('checked') == true){
        $(this).parent('label').addClass('is-active');
      }else{
        $(this).parent('label').removeClass('is-active');
      }
    })
    $("." + this.el).find('input[type=checkbox]').on('change',function(){
      if($(this).prop('checked') == true){
        $(this).parent('label').addClass('is-active');
      }else{
        $(this).parent('label').removeClass('is-active');
      }
    })
    $("." + this.el).find('input[type=radio]').on('change',function(){
      let radioName = $(this).attr('name');
      $('[name='+radioName+']').each(function(){
        if($(this).prop('checked') == true){
          $(this).parent('label').addClass('is-active');
        }else{
          $(this).parent('label').removeClass('is-active');
        }
      })
    })
  }
}

class ContactConfirm {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const formInput = '.mw_wp_form_input';
    const formConfirm = '.mw_wp_form_confirm';
    const formComplete = '.mw_wp_form_complete';
    const formInputText = '.js-contact-input';
    const formConfirmText = '.js-contact-confirm';
    const formCompleteText = '.js-contact-complete';
    const completeHide = '.js-contact-complete-hide';
    const formError = '.mw_wp_form_send_error';
    const errorHideWrap = '.js-contact-error-hide';
    if($(formInput).length){
      $(formConfirmText).hide();
      $(formCompleteText).hide();
    }
    if($(formConfirm).length){
      $(formInputText).hide();
      $(formCompleteText).hide();
    }
    if($(formComplete).length){
      $(formInputText).hide();
      $(formConfirmText).hide();
      $(completeHide).hide();
    }
    if($(formError).length){
      $(errorHideWrap).hide();
    }
  }
}

class ContactDatePicker {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const dateWrap = "." + this.el;
    $(dateWrap).each(function(){
      $(this).find('input[type=text]').attr('type','date');
    })
  }
}

class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class FaqAccordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const toggle = '.js-faq-accordion';
    $(toggle).on('click',function(){
      $(this).toggleClass('is-active');
      $(this).next().slideToggle();
    })
  }
}
class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const element = '.js-header';
    if(!isMobile()){
      // ヘッダーメニューをスクロールで表示・非表示
      let elementClass = $(element).attr('class');
      let elementHtml = $(element).html();
      let newElement = $('<div class="is-ready"></div>').addClass(elementClass).html(elementHtml);
      $(element).after(newElement);
    }
    const isUp = (function() {
      const scrollElement = document.scrollingElement;
      let flag, prePoint, scrollPoint;
      return function() {
        scrollPoint = scrollElement.scrollTop;
        flag = prePoint > scrollPoint ? true : false;
        prePoint = scrollPoint;
        return flag;
      }
    }());

    if($('.js-header').hasClass('non-scroll')){

    }else{
      window.addEventListener('scroll', function() {
        if(isMobile()){
          if (window.pageYOffset >= 300) {
            $(element).addClass('is-active').addClass('is-ready');
          }else{
            $(element).removeClass('is-active').removeClass('is-ready');
          }
        }else{
          if (window.pageYOffset >= 300) {
            $(element).next('.is-ready').addClass('is-active');
          }
          if(isUp()){
            $(element).next('.is-ready').removeClass('is-active');
          }
        }
      });
    }

    // スマホヘッダーメニューの開閉
    $(function(){
      let spToggle = '.js-sp-gm-toggle';
      let spNav ='.js-sp-nav';
      let headerWrap = '.js-header';
      $(spToggle).on('click',function(){
        $(spNav).slideToggle();
        $(headerWrap).toggleClass('is-toggle-active');
        if($(headerWrap).hasClass('is-scroll-active')){

        }else{
          // $(headerWrap).toggleClass('is-active');
        }
      })
    })
  }
}
class HomeLineUpSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.'+this.el, {
      speed: 10000,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 49,
      allowTouchMove: false,             // タッチ操作を無効にする
      preventClicks: true,               // スライダー上でのクリックを防ぐ
      preventClicksPropagation: true,    // クリックイベントの伝播を防ぐ
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        851: {
          slidesPerView: 3,
          spaceBetween: 90,
        }
      }
    })
  }
}

class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // ローディング中はスクロールを無効化
    function noscroll(e){
      e.preventDefault();
    }
    document.addEventListener('touchmove', noscroll, {passive: false});
    document.addEventListener('wheel', noscroll, {passive: false});

    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    // scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');

    const loadingBg = '.js-loading-bg';
    const loadingLogo = '.js-loading-logo';
    const loadingToLogo = '.js-loading-to-logo';
    const loadingHeader = '.js-loading-header';

    $(loadingHeader).css({opacity:0})

    if(isMobile()){
      setTimeout(() => {
        body.style.top = '';
        body.classList.remove('no_scroll');
        window.scrollTo(0, scrollTop);
  
        const mvTl = gsap.timeline()
        .to(loadingBg, 1, {
          opacity: 0
        })
        .to(loadingLogo,1 ,{
          scale: 0.92,
          opacity: 0,
        },'<')
        .to(loadingToLogo,1,{
          scale: 0.92,
          opacity: 1
        },'<')
        .to(loadingHeader,1.5,{
          opacity: 1,
          delay: -1
        })
      }, 1300);
    }else{
      setTimeout(() => {
        body.style.top = '';
        body.classList.remove('no_scroll');
        window.scrollTo(0, scrollTop);
  
        const mvTl = gsap.timeline()
        .to(loadingBg, 1, {
          x: '-90%',
          y: '21%',
        })
        .to(loadingLogo,1 ,{
          width: '12rem',
          opacity: 0,
        },'<')
        .to(loadingToLogo,1,{
          width: '12rem',
          opacity: 1
        },'<')
        .to(loadingHeader,1.5,{
          opacity: 1,
          delay: -1
        })
      }, 1300);
    }
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      // スクロールを許可
      document.removeEventListener('touchmove', noscroll);
      document.removeEventListener('wheel', noscroll);
    },2500)
  }
}
class MegaMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const gNavMenu = $(".js-header-menu");
    gNavMenu.children('li').hover(function(){
      $(this).toggleClass('is-active');
      gNavMenu.toggleClass('is-active');
      if($(this).hasClass('js-has-child-menu')){
        $(this).find('ul').stop().fadeToggle();
      }
    })
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class MoreProducts {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var page = 2; //初期ページ番号
    $("." + this.el).on('click', function (e) {
      e.preventDefault();
      let treeType = $(this).attr('data-cat');
      let productsSize = $(this).attr('data-size');
      let productsPrice = $(this).attr('data-price');
      let productsCat = $(this).attr('data-pcat');
      let productsWords = $(this).attr('data-words');
      $.ajax({
        url: ajaxurl,
        type: 'GET',
        data: {
          action: 'load_more_products',
          page: page,
          treeType: treeType,
          productsSize: productsSize,
          productsPrice: productsPrice,
          productsCat: productsCat,
          productsWords: productsWords,
        },
        success: function (response) {
          var data = JSON.parse(response);
            $('.js-more-products-contents').append('<div style="display:none;" class="new-posts">' + data.content + '</div>');
            $('.new-posts').fadeIn('slow');
          if (!data.hasMorePosts) {
              $('.js-more-products').fadeOut();
          } else {
              page++;
          }
        }
      });
    });
  }
}
class ProductsSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const swiperBar = '.js-products-swiper-scroll';
    const pageNation = '.swiper-wrapper';
    let pageNationCount = $(pageNation).find('.swiper-slide').length;
    let swiperBarHeight = $(swiperBar).outerHeight();
    const swiperBarGrow = 100 / pageNationCount;
    console.log(swiperBarGrow);
    console.log(swiperBarHeight);
    console.log(pageNationCount);
    $(swiperBar).find('span').css('height',swiperBarGrow + '%');
    const swiperBarChange = function(slideNum){
      // console.log(swiperBarGrow);
      // console.log(slideNum);
      let Grow = swiperBarGrow * slideNum;
      // if(pageNationCount == slideNum){
      //   Grow = 100;
      // }else{
      //   Grow = swiperBarGrow * slideNum;
      // }
      $(swiperBar).find('span').css('height',Grow + '%');
      console.log(Grow);
    }
    const swiper = new Swiper('.' + this.el, {
      speed: 500,
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          // スライダーの画像のsrcを取得して、それをページネーションのサムネイルとして使用
          var src = document.querySelectorAll('.swiper-slide img')[index + 1].getAttribute('src');
          return '<span class="' + className + '"><img src="' + src + '" alt="" width="50"></span>';
        }
      },
      on: {
        slideChange: function(){
          let slideNum = this.activeIndex;
          swiperBarChange(slideNum);
        }
      }
    })
  }
}

class ScrollBar {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $(document).ready(function () {
      var $innerDiv = $('.js-scroll-bar > div');

      // 全体のスクロール可能な高さを取得
      var totalHeight = $(document).height() - $(window).height();

      $(window).on('scroll', function () {
        // 現在のスクロール位置を取得
        var scrollTop = $(window).scrollTop();

        // スクロールの進行度を計算（0から1までの値）
        var scrollPercentage = scrollTop / totalHeight;

        // .js-process-bar > divの新しい高さを%で計算
        var newHeight = scrollPercentage * 100;

        // 新しい高さを適用
        $innerDiv.css('height', newHeight + '%');
      });
    });

  }
}

class SearchForm {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const searchList = '.js-search-list';
    const searchItem = '.js-search-item';
    const inputItem = '.js-search-input';
    const inputTtl = '.js-search-ttl';
    $(inputTtl).on('click',function(){
      const item = $(this).next(searchList);      

      $(".js-search-list").not(item).fadeOut(100, function () {});
      $(".js-search-list").not(item).removeClass('is-active');

      if(item.hasClass('is-active')) {
        item.removeClass('is-active');
        item.fadeOut(100, function () {
        });
      }else{
        item.addClass('is-active');
        item.fadeIn(100, function () {
        });
      }
    })

    $(searchItem).on('click',function(){
      $(this).parents(searchList).fadeToggle(100);
    })
    $(searchItem).on('click',function(){
      let dataName = $(this).data('name');
      let dataId = $(this).data('id');
      let dataText = $(this).text();
      $(inputItem+'[name='+dataName+']').val(dataId);
      $(inputTtl+'[data-name='+dataName+']').find('span').text(dataText);
    })

    // スマホ検索
    const spSearchToggle = '.js-sp-search-toggle';
    const spSearchWrap = '.js-sp-search-wrap';
    const spSearchBg = '.js-sp-search-bg';
    const spSearchClose = '.js-sp-search-close';

    $(spSearchToggle).on('click',function(){
      $(spSearchWrap).fadeIn();
      $(spSearchBg).fadeIn();
    })
    $(spSearchBg).on('click',function(){
      $(spSearchWrap).fadeOut();
      $(spSearchBg).fadeOut();
    })
    $(spSearchClose).on('click',function(){
      $(spSearchWrap).fadeOut();
      $(spSearchBg).fadeOut();
    })
  }
}

class SecondLoading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // ローディング中はスクロールを無効化
    function noscroll(e){
      e.preventDefault();
    }
    document.addEventListener('touchmove', noscroll, {passive: false});
    document.addEventListener('wheel', noscroll, {passive: false});

    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    // scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');

    const loadingBg = '.js-loading-bg';
    const loadingLogo = '.js-loading-logo';

    if(isMobile()){
      setTimeout(() => {
        body.style.top = '';
        body.classList.remove('no_scroll');
        window.scrollTo(0, scrollTop);
  
        const mvTl = gsap.timeline()
        .to(loadingBg, 1, {
          opacity: 0
        })
        .to(loadingLogo,1 ,{
          scale: 0.92,
          opacity: 0,
        },'<')
      }, 1300);
    }else{
      setTimeout(() => {
        body.style.top = '';
        body.classList.remove('no_scroll');
        window.scrollTo(0, scrollTop);
  
        const mvTl = gsap.timeline()
        .to(loadingBg, 1, {
          x: '-90%',
          y: '21%',
        })
        .to(loadingLogo,0.5 ,{
          width: '12rem',
          opacity: 0,
        },'<')
      }, 1300);
    }
    setTimeout(() => {
      $(".c-second-loading").fadeOut(500);
      // スクロールを許可
      document.removeEventListener('touchmove', noscroll);
      document.removeEventListener('wheel', noscroll);
    },2500)
  }
}
class ShowroomSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const swiper = new Swiper('.' + this.el, {
      speed: 500,
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,  // if you want the dots to be clickable
      },
      autoplay: {
        delay: 3000,   // 3 seconds delay between slides
        disableOnInteraction: false,  // Continue autoplay even after user interaction
      },
    })
  }
}

class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    jQuery(function($){
      // #で始まるアンカーをクリックした場合に処理
      $('a[href^="#"]').click(function(){
        // 移動先を50px上にずらす
        if(isMobile()){
          var adjust = 100;
        }else{
          var adjust = 150;
        }
        // スクロールの速度
        var speed = 400; // ミリ秒
        // アンカーの値取得
        var href= $(this).attr("href");
        // 移動先を取得
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を調整
        var position = target.offset().top - adjust;
        // スムーススクロール
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
      });
    });
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
class TreeTypeModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalToggle = '.js-treetype-modal-toggle';
    const modalWrap = '.js-treetype-modal';
    const modalClose = '.js-treetype-modal-close';
    const modalContent= '.js-treetype-modal-content';
    $(modalToggle).on('click',function(){
      let modalNum = $(this).data('modal');
      $(modalWrap).find('[data-modal='+modalNum+']').css('visibility','visible');
      $(modalWrap).fadeIn();
    })
    $(modalClose).on('click',function(){
      $(modalWrap).fadeOut();
      setTimeout(function(){
        $(modalContent).css('visibility','hidden');
      },500)
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })  

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Movie {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let scrollPosition = 0;

    $('.js-movie-trigger').on('click', function() {
      // 現在のスクロール位置を保存
      scrollPosition = $(window).scrollTop();
      
      // モーダルを開く
      $('.js-movie-modal').toggleClass('is-active');
      $('body').addClass('no_scroll').css({
        'top': -scrollPosition + 'px'
      });
    
      if ($('.js-movie-modal').hasClass('is-active')) {
        $('.js-movie-video').get(0).play();
      }
    });
    
    $('.js-movie-back').on('click', function(event) {
      event.preventDefault(); // デフォルトの動作を防ぐ
    
      // 動画を停止し、最初に戻す
      $('.js-movie-video').get(0).pause();
      $('.js-movie-video').get(0).currentTime = 0;
    
      // no_scrollクラスを外してスクロール位置を復元
      $('body').removeClass('no_scroll').css({
        'top': ''
      });
      window.scrollTo(0, scrollPosition);
    
      // モーダルを閉じる
      $('.js-movie-modal').removeClass('is-active');
    });
    
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let scrollBar = new ScrollBar('js-scroll-bar');
  let treeTypeModal = new TreeTypeModal('js-treetype-modal');
  let fawAccordion = new FaqAccordion('js-faq-accordion');
  let productsSwiper = new ProductsSwiper('js-products-swiper');
  let searchForm = new SearchForm('js-search-form');
  let moreProducts = new MoreProducts('js-more-products');
  let showroomSwiper = new ShowroomSwiper('js-showroom-swiper');
  let contactCheckbox = new ContactCheckBox('js-contact-checkbox');
  let contactConfirm = new ContactConfirm('js-contact-confirm');
  let contactAddAcceptLink = new ContactAddAcceptLink('c-mw-form-acceptance');
  // let contactDatePicker = new ContactDatePicker('js-contact-date-picker');
  let smoothScroll = new SmoothScroll();
  
  // TOPページ
  let homeLineUpSwiper = new HomeLineUpSwiper('js-home-lineup-slider');
  let movie = new Movie('js-movie-trigger');
  
  // ヘッダースクロール
  let headerScroll = new HeaderScroll('js-header');
  let megaMenu = new MegaMenu('js-header-menu');

  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let secondLoading = new SecondLoading('c-second-loading');
  let editor = new Editor('c-editor');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });